// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { tgfHooks } from "../framework/hooks/hooks";
import { FriendInvites } from "../settings/Settings";
import { FriendManager } from "./FriendManager";
import { YoutubeStorageManager } from "./storage/YoutubeStorageManager";
export var InviteFriendManager = function (data) {
    this._data = data;
    this._backendTag = "inviteFriends";
    this._invitedContext = [];
    this._inviteMax = FriendInvites.inviteMax;
    this._unlockBird = false;
    this._isFirstMatildaTurn = false;
    this._initialize();
};
InviteFriendManager.prototype._initialize = function () {
    "use strict";
    if (this._data && this._data[this._backendTag]) {
        this._invitedContext = this._data[this._backendTag];
    }
};
InviteFriendManager.prototype._checkSuggestedFriends = function (callback, fail) {
    "use strict";
    tgfHooks.getContextPlayers(function (players) {
        var _opponent = null;
        var _suggestList = [];
        var _exists = false;
        for (var i = 0; i < players.length; i++) {
            if (players[i].getID() != tgfHooks.getPlayerID()) {
                _opponent = players[i].getID();
                _suggestList = FriendManager.getFriendIds();
                for (var y = 0; y < _suggestList.length; y++) {
                    if (_suggestList[y] === _opponent) {
                        _exists = true;
                    }
                }
                break;
            }
        }
        if (callback) {
            callback(_exists);
        }
    }, function (error) {
        if (fail) {
            fail();
        }
        console.log(error);
    });
};
InviteFriendManager.prototype._saveInvitedContext = function () {
    "use strict";
    var self = this;
    YoutubeStorageManager.savePlayerData([this._backendTag], [this._invitedContext], function () {
        console.log("success Invite");
    }, function (error) {
        console.log(error);
    });
};
InviteFriendManager.prototype._didInvite = function (context, success, duplicate, fail) {
    "use strict";
    var self = this;
    for (var i = 0; i < this._invitedContext.length; i++) {
        if (this._invitedContext[i] === context) {
            if (duplicate) {
                duplicate();
            }
            return;
        }
    }
    self._invitedContext.push(context);
    if (self.unlockBird()) {
        self._isFirstMatildaTurn = true;
    }
    self._saveInvitedContext();
    success();
};
InviteFriendManager.prototype.startInvite = function (success, duplicate, fail) {
    "use strict";
    var self = this;
    tgfHooks.chooseContext(function () {
        self._didInvite(tgfHooks.getContextID(), success, duplicate, fail);
    }, fail, { filters: ["NEW_PLAYERS_ONLY"], maxSize: 2 });
};
InviteFriendManager.prototype.getInvited = function () {
    "use strict";
    return this._invitedContext;
};
InviteFriendManager.prototype.unlockBird = function () {
    "use strict";
    if (this._invitedContext.length === this._inviteMax) {
        this._unlockBird = true;
    }
    return this._unlockBird;
};
InviteFriendManager.prototype.isFirstMatildaTurn = function () {
    "use strict";
    return this._isFirstMatildaTurn;
};
InviteFriendManager.prototype.onFinishTurn = function () {
    "use strict";
    this._isFirstMatildaTurn = false;
};
